/* eslint-disable */
import EN from './EN';

export {
  EN
};
